// Globals
import { useTranslation } from 'react-i18next';

// Components
import { FormItem, IFormInstance } from '@/components';
import { Button, Select } from '@/ui';
import { StyledForm, StyledParagraph, StyledTitle, StyledWrapper } from './CleanSyncFormStyles';

// Helpers
import { CleanSyncFormFormFields, getChannelsOptions, TCleanSyncFormValues } from '../../helpers';

// Models
import { IChannel } from '@/models/channel.model';
import { useCleanSyncFormRules } from '../../hooks/useCleanSyncFormRules';

type TCleanSyncFormProps = {
  cleanSyncForm: IFormInstance;
  onSubmit: (values: TCleanSyncFormValues) => void;
  channels: IChannel[];
};

const CleanSyncForm = ({ onSubmit, cleanSyncForm, channels }: TCleanSyncFormProps) => {
  const { t } = useTranslation();
  const rules = useCleanSyncFormRules();
  const channelsOptions = getChannelsOptions(channels);

  return (
    <StyledWrapper>
      <StyledTitle>{t('title_clean_sync')}</StyledTitle>
      <StyledParagraph>{t('description_clean_sync')}</StyledParagraph>
      <StyledForm onFinish={onSubmit} form={cleanSyncForm}>
        <FormItem
          name={CleanSyncFormFormFields.CHANNEL}
          label={t('label_channels')}
          rules={rules[CleanSyncFormFormFields.CHANNEL]}
        >
          <Select options={channelsOptions} allowClear />
        </FormItem>
        <Button block type="primary" htmlType="submit" title={t('button_clean_sync_title')}>
          {t('button_clean_sync_products')}
        </Button>
      </StyledForm>
    </StyledWrapper>
  );
};

export default CleanSyncForm;
